import { DetailsPage } from "apps/oneOnboarding/details/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(DetailsPage, "DetailsPage");
